<template>
  <li class="menu-list__item">
    <span v-on:click="toggle" class="menu-list__link menu_down-green" v-bind:class="{'active' : menuItem === _uid}">{{value.Name}}</i></span>
    <ul v-if="menuItem === _uid" class="submenu-list menu_up-green" transition>
      <li class="submenu-list__item" v-for="subitem in value.Items">
        <a href="#" class="submenu-list__link" v-on:click.prevent="navigate(subitem)">
          {{subitem.Name}}
        </a>
      </li>
      <li class="submenu-list__item submenu-list__item--push">
        <a href="#" class="submenu-list__link" v-on:click="toggle">
          &nbsp;
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
  export default {
    props: ["value"],
    data () {
      return {
        routeNames: {
          FileList: "/products/",
          Image: "/images/",
          ImageFilter: "/images/filter/"
        }
      };
    },

    vuex: {
      getters: {
        menuItem: state => state.menuItem
      }
    },

    methods: {
      toggle () {
        this.$dispatch("submenu_clicked", this._uid, false);
      },
      navigate (item) {
        this.toggle();

        if (item.IsProductLinked) {
          var id = item.PageCategoryIds || "null";
          var filetype = item.FileType ? "/filetype/" + item.FileType : "";

          this.$router.go(this.routeNames[item.Type] + id + filetype);
        } else {
          this.$router.go("/documents/" + item.FileType);
        }
      }
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  @import '../../assets/scss/devices.scss';
  
  .menu-list{
    &__item{
      position: relative;
      box-sizing: border-box;
      // float: left;
      display: inline-block;
      text-align: left;
      margin-right: 2%;
      font-weight: bold;
      font-size: 14px;
      // width: 20%;
      @include min-screen(1250px){
        width: 20%;
        display: block;
        margin-right: 0;
        float: left;
      }
    }

    &__link{
      color: $green_dark;
      display: block;
      padding: 28px 0px 23px 20px;
      position: relative;
      z-index: 1;
      background: $white;
      cursor: pointer;

      .transparent &{
        color: $white;
        background: transparent;
      }

      &.active{
        z-index: 3;
      }

      &.active:after{
        opacity: 0;
      }

      &:hover{
        text-decoration: none;
      }
    }
  }

  .menu_down-green:after, .menu_up-green:after{
    bottom: 0px;
    content: "";
    display: block;
    height: 20px;
    position: absolute;
    width: 10px;
    transition: opacity 0.25s;
  }

  .menu_up-green:after{
    bottom: 10px;
  }

  .icon-menu_down{
    display: block;
  }

  .submenu-list{
    background: $white;
    box-sizing: border-box;
    font-size: 15px;
    list-style: none;
    padding: 63px 10px 40px 20px;
    position: absolute;
    top: 0;
    width: 100%;
    min-width: 180px;
    z-index: -1;
    border: 1px solid $green_light;

    .transparent &{
      background: rgba(0,0,0, .75);
      border: none;
      z-index: 2;
    }

    &__item{
      font-weight: normal;
      font-size: 14px;

      &--push{
        margin-bottom: -36px;
        z-index: 1;
        position: relative;
        a:hover{
          text-decoration: none;
        }
      }
    }

    &__link{
      color: $green_dark;
      display: block;
      padding: 9px 0;

      .transparent &{
        color: $green_light;
      }
    }

    transition: all .25s;

    &.v-enter, &.v-leave{
      top: -200px;
      opacity: 0;
    }
  }

</style>


// WEBPACK FOOTER //
// NavigationMenuItem.vue?1b730178